// extracted by mini-css-extract-plugin
export var footer = "_os-5";
export var fulfillmentInput = "_os-0";
export var shipDateInput = "_os-1";
export var shipmentModal = "_os-2";
export var shipmentModalContent = "_os-3";
export var tableContainer = "_os-4";